export default {
  host: 'https://api.pokemontcg.io/v2'
};